import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone'
})

export class PhonePipe implements PipeTransform {
  transform(value: string): string {
    var returnValue: string = 'N/A';

    if (value.length === 10)
      returnValue = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6);

    return returnValue;
  }
}
